import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { getSearchUsers } from '../../../../../crud/users.crud';
import { TUserParamsSearch } from '../../../../../components/ui/UsersFilter/types';
import { IUser } from '../../../../../interfaces/user';
import { useFormatMessage } from '../../../../../hooks';
import { getResponseMessage } from '../../../../../utils/utils';

export const useSearchBuyer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<IUser[]>([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const fm = useFormatMessage();

  const fetchUsers = async (params: Partial<TUserParamsSearch>) => {
    setLoading(true);
    setUsers([]);
    getSearchUsers(params)
      .then(res => {
        if (res.data.data.length === 0) {
          setIsEmpty(true);
          setUsers([]);
        } else {
          setIsEmpty(false);
          setUsers(res.data.data);
        }
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`, { variant: 'error' });
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 100);
      });
  };

  return { fetchUsers, loading, users, setUsers, setIsEmpty, isEmpty };
};
